// extracted by mini-css-extract-plugin
module.exports = {"story-card":"styles-m__story-card__3w7kc","blank-story-element":"styles-m__blank-story-element__2i8Gd"};